"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.map.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Item = _interopRequireDefault(require("./Item"));

var _Category = _interopRequireDefault(require("./Category"));

var _style = require("./style");

var _excluded = ["dataSource", "value", "onChange"],
    _excluded2 = ["category"],
    _excluded3 = ["value", "label"];

var _this = void 0;

var itemShape = {
  /**
   * item的唯一键
   */
  value: _propTypes["default"].any,

  /**
   * item的展示文本
   */
  label: _propTypes["default"].node,

  /**
   * category的名称
   */
  category: _propTypes["default"].string,

  /**
   * 国旗/区旗图标ID
   */
  flag: _propTypes["default"].string,

  /**
   * 是否禁用
   */
  disabled: _propTypes["default"].bool,

  /**
   * 角标气泡配置，默认不显示
   */
  bubble: _propTypes["default"].object,

  /**
   * tooltip配置，默认不显示
   */
  tooltip: _propTypes["default"].object
};
/**
 * RegionMenu
 * @description 地域选择菜单
 */

var RegionMenu = function RegionMenu(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var dataSource = _ref.dataSource,
      value = _ref.value,
      onChange = _ref.onChange,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var noCategoryItems = [];
  var itemsCategoryMap = {};
  dataSource.forEach(function (data) {
    (0, _newArrowCheck2["default"])(this, _this2);
    var category = data.category,
        rest = (0, _objectWithoutProperties2["default"])(data, _excluded2);

    if (!category) {
      noCategoryItems.push(data);
      return;
    }

    if (itemsCategoryMap[category]) {
      itemsCategoryMap[category].push(rest);
    } else {
      itemsCategoryMap[category] = [rest];
    }
  }.bind(this));

  var renderItems = function renderItems() {
    var _this3 = this;

    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return items.map(function (item, i) {
      (0, _newArrowCheck2["default"])(this, _this3);
      var val = item.value,
          label = item.label,
          rest = (0, _objectWithoutProperties2["default"])(item, _excluded3);
      var isSelected = val === value;
      return /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({
        key: i,
        value: val,
        selected: isSelected,
        onSelect: onChange
      }, rest), label);
    }.bind(this));
  };

  var renderNoCategoryItems = function renderNoCategoryItems() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (!noCategoryItems.length) {
      return null;
    }

    return renderItems(noCategoryItems);
  }.bind(this);

  var renderCategories = function renderCategories() {
    var _this4 = this;

    (0, _newArrowCheck2["default"])(this, _this2);
    var categories = (0, _keys["default"])(itemsCategoryMap);
    return categories.map(function (category, i) {
      (0, _newArrowCheck2["default"])(this, _this4);
      var items = renderItems(itemsCategoryMap[category]);
      return /*#__PURE__*/_react["default"].createElement(_Category["default"], {
        title: category,
        key: i
      }, items);
    }.bind(this));
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_style.StyledMenuWrapper, others, renderNoCategoryItems(), renderCategories());
}.bind(void 0);

RegionMenu.propTypes = {
  /**
   * 数据数组
   */
  dataSource: _propTypes["default"].arrayOf(_propTypes["default"].shape(itemShape)),

  /**
   * 选中的菜单项的key，controlled
   */
  value: _propTypes["default"].any,

  /**
   * 选中变化时的回调
   */
  onChange: _propTypes["default"].func,

  /** @ignore */
  children: _propTypes["default"].node
};
RegionMenu.defaultProps = {
  dataSource: [],
  onChange: function onChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0)
};
var _default = RegionMenu;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/RegionMenu/RegionMenu.js
// module id = 2142
// module chunks = 6 7 17 18